import { render } from "./QuestItem.vue?vue&type=template&id=3ca54987&scoped=true"
import script from "./QuestItem.vue?vue&type=script&lang=js"
export * from "./QuestItem.vue?vue&type=script&lang=js"

import "./QuestItem.vue?vue&type=style&index=0&id=3ca54987&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca54987"]])

export default __exports__